/* Verdette v8 motion + conversion helpers. transform/opacity only; IntersectionObserver for reveals; scroll work batched in rAF. */
(() => {
'use strict';
const root=document.documentElement;root.classList.add('v8-js');
const reduce=matchMedia('(prefers-reduced-motion: reduce)');
const finePointer=matchMedia('(hover:hover) and (pointer:fine)');

/* 1. Hero entrance: mark ready on next frame so the stagger plays once fonts/layout exist. */
requestAnimationFrame(()=>requestAnimationFrame(()=>root.classList.add('v8-ready')));

/* 2. Scroll reveals (sections + staggered children). Content is visible without JS; hidden only once the observer is confirmed. */
if('IntersectionObserver' in window&&!reduce.matches){
 root.classList.add('v8-reveal-on');
 const io=new IntersectionObserver(entries=>entries.forEach(e=>{if(e.isIntersecting){e.target.classList.add('revealed');io.unobserve(e.target)}}),{threshold:.14,rootMargin:'0px 0px -6% 0px'});
 document.querySelectorAll('[data-reveal]').forEach(el=>io.observe(el));
 /* safety: anything still hidden after 2.5s becomes visible (skip-link jumps, odd layouts) */
 setTimeout(()=>document.querySelectorAll('[data-reveal]:not(.revealed)').forEach(el=>{if(el.getBoundingClientRect().top<innerHeight)el.classList.add('revealed')}),2500);
}

/* 3. Mouse tilt on the hero product stage (desktop, fine pointer only). */
const stage=document.querySelector('[data-tilt3d]');
if(stage&&finePointer.matches&&!reduce.matches){
 let frame=0,tx=0,ty=0;
 const img=stage.querySelector('.v8-stage-img');
 stage.addEventListener('pointermove',e=>{const r=stage.getBoundingClientRect();tx=((e.clientX-r.left)/r.width-.5);ty=((e.clientY-r.top)/r.height-.5);if(!frame)frame=requestAnimationFrame(()=>{frame=0;img.style.setProperty('--rx',(-ty*14).toFixed(2)+'deg');img.style.setProperty('--ry',(tx*18).toFixed(2)+'deg');img.style.setProperty('--px',(tx*18).toFixed(1)+'px');img.style.setProperty('--py',(ty*14).toFixed(1)+'px')})});
 stage.addEventListener('pointerleave',()=>{cancelAnimationFrame(frame);frame=0;['--rx','--ry','--px','--py'].forEach(p=>img.style.removeProperty(p))});
}

/* 4. Magnetic buttons. */
if(finePointer.matches&&!reduce.matches){
 document.querySelectorAll('[data-magnetic]').forEach(btn=>{
  let frame=0;
  btn.addEventListener('pointermove',e=>{const r=btn.getBoundingClientRect();const x=(e.clientX-r.left-r.width/2)*.28,y=(e.clientY-r.top-r.height/2)*.28;if(!frame)frame=requestAnimationFrame(()=>{frame=0;btn.style.transform=`translate(${x.toFixed(1)}px,${y.toFixed(1)}px)`})});
  btn.addEventListener('pointerleave',()=>{cancelAnimationFrame(frame);frame=0;btn.style.transform=''});
 });
}

/* 5. Marquee pause control (WCAG 2.2.2). */
const mq=document.querySelector('.v8-marquee');
if(mq){const b=mq.querySelector('.v8-marquee-toggle');b.addEventListener('click',()=>{const paused=mq.toggleAttribute('data-paused');b.textContent=paused?'▷':'Ⅱ';b.setAttribute('aria-pressed',String(paused));b.setAttribute('aria-label',paused?'Play moving text':'Pause moving text')})}

/* 6. Scroll-linked parallax + spin fallback when CSS scroll-driven animations are unsupported. */
if(!CSS.supports('animation-timeline: view()')&&!reduce.matches){
 const items=[...document.querySelectorAll('[data-parallax],[data-spin-scroll]')];
 if(items.length){let frame=0;
  const draw=()=>{frame=0;const h=innerHeight;items.forEach(el=>{const r=el.getBoundingClientRect();if(r.bottom<0||r.top>h)return;const p=(r.top+r.height/2-h/2)/h;/* -0.5..0.5 */
   if(el.hasAttribute('data-spin-scroll'))el.style.transform=`rotate(${(-16+p*-60).toFixed(1)}deg)`;else el.style.transform=`translateY(${(p*-28).toFixed(1)}px) scale(1.08)`})};
  addEventListener('scroll',()=>{if(!frame)frame=requestAnimationFrame(draw)},{passive:true});draw();
 }
}

/* 7. Delivery window: today + 1–3 business days processing + 7–20 business days transit. Estimates, not promises. */
const addBiz=(d,n)=>{const x=new Date(d);let c=0;while(c<n){x.setDate(x.getDate()+1);const w=x.getDay();if(w!==0&&w!==6)c++}return x};
document.querySelectorAll('[data-delivery-window]').forEach(el=>{const now=new Date(),a=addBiz(now,8),b=addBiz(now,23);const f=d=>d.toLocaleDateString('en-AU',{weekday:'short',day:'numeric',month:'short'});el.textContent=`${f(a)} – ${f(b)}`;el.title='Estimated. 1–3 business days processing plus 7–20 business days transit.'});

/* 8. Quantity choice updates the button label. */
document.querySelectorAll('.purchase-form').forEach(form=>{
 const radios=form.querySelectorAll('input[name=quantity][type=radio]');if(!radios.length)return;
 const label=form.querySelector('[name=add]>span:first-child');const price=parseFloat(form.querySelector('.v8-qty-choice label small')?.textContent.replace(/[^0-9.]/g,''))||0;
 const money=n=>'$'+n.toFixed(2);
 radios.forEach(r=>r.addEventListener('change',()=>{const q=Number(r.value);label.textContent=q===2?`Add 2 to bag — ${money(Math.round(price*2*0.75*100)/100)}`:`Add to bag — ${money(price)}`}));
});

/* 9. Homepage sticky buy bar: appears after the hero, hides while the real buy block is on screen. */
const sticky=document.querySelector('[data-sticky-buy]'),hero=document.querySelector('.v8-hero'),shop=document.querySelector('#shop .purchase-form');
if(sticky&&hero&&shop&&'IntersectionObserver' in window){
 let pastHero=false,shopVisible=false;const update=()=>{sticky.hidden=!(pastHero&&!shopVisible)};
 new IntersectionObserver(([e])=>{pastHero=!e.isIntersecting&&e.boundingClientRect.bottom<0;update()},{threshold:0}).observe(hero);
 new IntersectionObserver(([e])=>{shopVisible=e.isIntersecting;update()},{threshold:0}).observe(shop);
 sticky.querySelector('[data-sticky-add]').addEventListener('click',()=>{shop.querySelector('[name=add]').click();shop.scrollIntoView({behavior:reduce.matches?'auto':'smooth',block:'center'})});
}
})();
